(function () {
    const documentReady = () => {
        const lightbox = document.querySelector('.diu-content-lightbox');
        const lightboxClose = document.querySelector('.diu-content-lightbox__close');
        const lightboxContentElement = document.querySelector('.diu-content-lightbox__content');
        const lightboxImages = document.querySelectorAll('.diu-content-lightbox__enabled.diu-content-lightbox__img');
        if (lightbox && lightboxContentElement && lightboxImages.length > 0) {
            lightboxImages.forEach(function (lightboxImage) {
                lightboxImage.addEventListener('click', function () {
                    const source = getImagePath(this);

                    if (source === null) {
                        return;
                    }

                    const img = new Image();
                    img.src = source;
                    lightboxContentElement.innerHTML = '';
                    lightboxContentElement.appendChild(img);
                    lightbox.classList.remove('d-none');
                });
            });
        }

        if (lightboxClose && lightbox) {
            lightboxClose.addEventListener('click', function () {
                lightbox.classList.add('d-none');
            });
        }
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;
        documentReady();
    });

    function getImagePath(el) {
        const src = el.querySelector('source');
        const image = el.querySelector('img');
        let path = null;

        if (src) {
            path = getPathBySrcset(src.srcset);
        }

        if (image && path === null) {
            path = image.currentSrc;
        }

        return path;
    }

    function getPathBySrcset(srcset) {
        if (!srcset) {
            return null;
        }

        const windowWidth = window.innerWidth;
        const srcsetArray = getArrayOfSrcset(srcset);

        if (srcset.length < 1) {
            return null;
        }

        let imagePath = null;
        srcsetArray.forEach(function (srcSet) {
            if (windowWidth > parseInt(srcSet.width)) {
                imagePath = srcSet.href;
            }
        });

        return imagePath;
    }

    function getArrayOfSrcset(srcset) {
        const srcsetArray = srcset.trim().split(',');
        const hrefArray = [];

        if (srcsetArray.length < 1) {
            return null;
        }

        srcsetArray.forEach(function (srcset) {
            const pathSet = srcset.trim().split(' ');

            if (pathSet.length !== 2) {
                return;
            }

            const width = pathSet[1].replace(/w/gi, '');
            const href = pathSet[0];

            hrefArray.push({ width: width, href: href });
        });

        return getSortedArray(hrefArray);
    }

    function getSortedArray(array) {
        array.sort(function (a, b) {
            return a.width - b.width;
        });

        return array;
    }
})();
